import axios, { endpoints } from 'src/utils/axios';
import handleOKRequest from 'src/components/grids/generic-grid/handleOKRequest';
import handleBadRequest from 'src/components/grids/generic-grid/handleBadRequest';
import { createAsyncThunk } from '@reduxjs/toolkit';

//Modificar de acuerdo a la lógica de la acción
export const verificarMatrizF = createAsyncThunk(
  'matrizForm/verificarMatrizF',
  async (
    { data, formRef }: { data: any; formRef: any },
    { rejectWithValue }
  ) => {
    try {
      const response = await axios.put(
        endpoints.actions.verificarMatrizF,
        data
      );
      formRef.current.instance.updateData({ id: response.data });
      handleOKRequest(response, 'Se marcó la matriz como "Verificada".');
      return response.data;
    } catch (error) {
      handleBadRequest(error);
      return rejectWithValue(
        error.response?.data || 'Error al marcar la matriz como "Verificada".'
      );
    }
  }
);

//Modificar de acuerdo a la lógica de la acción
export const discontinuarMatriz = createAsyncThunk(
  'matrizForm/discontinuarMatriz',
  async ({ data }: { data: any }, { rejectWithValue }) => {
    try {
      const response = await axios.put(
        endpoints.actions.discontinuarMatriz,
        data
      );
      handleOKRequest(response, 'Se marcó la matriz como "Discontinuada".');
      return response.data;
    } catch (error) {
      handleBadRequest(error);
      return rejectWithValue(
        error.response?.data ||
          'Error al marcar la matriz como "Discontinuada".'
      );
    }
  }
);

//Modificar de acuerdo a la lógica de la acción
export const marcarAveriadaMatrizF = createAsyncThunk(
  'matrizForm/marcarAveriadaMatrizF',
  async ({ data }: { data: any }, { rejectWithValue }) => {
    try {
      const response = await axios.put(
        endpoints.actions.marcarAveriadaMatrizF,
        data
      );
      handleOKRequest(response, 'Se marcó la matriz como "Averiada".');
      return response.data;
    } catch (error) {
      handleBadRequest(error);
      return rejectWithValue(
        error.response?.data || 'Error al marcar la matriz como "Averiada".'
      );
    }
  }
);

//Modificar de acuerdo a la lógica de la acción
export const marcarEnReparacionMatrizF = createAsyncThunk(
  'matrizForm/marcarEnReparacionMatrizF',
  async ({ data }: { data: any }, { rejectWithValue }) => {
    try {
      const response = await axios.put(
        endpoints.actions.marcarEnReparacionMatrizF,
        data
      );
      handleOKRequest(response, 'Se marcó la matriz como "En Reparación".');
      return response.data;
    } catch (error) {
      handleBadRequest(error);
      return rejectWithValue(
        error.response?.data ||
          'Error al marcar la matriz como "En Reparación".'
      );
    }
  }
);
